import React from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import { Colors } from "baseStyles/enums/colors";
import { RadioButton } from "../../schoolUiComponents/basic/Radio";
import { FlexProps } from "../../schoolUiComponents/basic/Box/FlexBox/types";
import MergeStudentStyles from "./styles";
import { interactedAddreplaceStudentProfileScreenEvent } from "../events";
import { IChild, IReferralData } from ".";
import StringUtility from "utility/string";


export const ChildWithoutImage = ({ child, selectExistingChild, replaceChild, existingChild, referralData }: { child: IChild, selectExistingChild: (child: IChild) => void, replaceChild: IChild, existingChild: IChild[], referralData: IReferralData }) => {
    const styles = MergeStudentStyles();
    if(!child) {
        return;
    }
  return (
      <FlexBox gap={4} borderRadius={8} backgroundColor={Colors.WHITE} alignItems={FlexProps.AlignItems.FLEX_START} padding={6} noWrap {...styles.childWithoutImage}>
          <FlexBox padding={4}><RadioButton clickHandler={() => { 
            selectExistingChild(child)
            interactedAddreplaceStudentProfileScreenEvent({ clickedOn: "Student profile", linkedStudentCount: existingChild.length.toString(), grade: child.grade_code, ...referralData });
            }} selected={child.id === replaceChild?.id} defaultAppearance={false} /></FlexBox>
          <FlexBox column gap={4} width = {"calc(100% - 28px)"} alignStart>
              <Text.NORMAL color={Colors.BLACK} emphasis fullWidth lines={2}>{StringUtility.formatFullName(child.first_name, child.last_name)}</Text.NORMAL>
              {!!child?.grade && <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY}>{child.grade}</Text.SMALL>}
          </FlexBox>
      </FlexBox>
  )
}